import { render } from "./DynamicResourcesCard.vue?vue&type=template&id=ae511200"
import script from "./DynamicResourcesCard.vue?vue&type=script&lang=js"
export * from "./DynamicResourcesCard.vue?vue&type=script&lang=js"

import "./DynamicResourcesCard.vue?vue&type=style&index=0&id=ae511200&lang=scss"
script.render = render

export default script